import React from 'react'
import Image from 'next/legacy/image'
import { useTranslation } from 'next-i18next'
import clsx from 'clsx'
import IconArrowTopRight from '../Icon/IconArrowTopRight'

type Props = {
  image?: string
  imageWidth?: number
  imageHeight?: number
  href?: string | null
  headline: string
  description?: string | null
  duration?: string | null
  persons?: string | null
  price?: string | null
  className?: string
}

const CardActivity: React.FC<Props> = ({
  image = undefined,
  imageWidth = 416,
  imageHeight = 480,
  href = undefined,
  headline,
  description = undefined,
  duration = undefined,
  persons = undefined,
  price = undefined,
  className = undefined,
}) => {
  const { t } = useTranslation()
  return (
    <div className={clsx('flex flex-col', className)}>
      {image && href && (
        <a className="block" href={href} target="_blank" rel="noreferrer">
          <Image
            src={image}
            width={imageWidth}
            height={imageHeight}
            alt={headline}
            className="rounded-2xl"
            layout="responsive"
          />
        </a>
      )}
      {image && !href && (
        <Image
          src={image}
          width={imageWidth}
          height={imageHeight}
          alt={headline}
          className="rounded-2xl"
          layout="responsive"
        />
      )}
      <h3 className="my-3 min-h-[50px] text-xl font-semibold">
        {href && (
          <a href={href} target="_blank" rel="noreferrer">
            {headline}
          </a>
        )}
        {!href && <a>{headline}</a>}
      </h3>

      {description && <p className="mb-3 pb-2 text-sm text-gray-800">{description}</p>}

      {(duration || persons || price) && (
        <div className="mb-3 space-y-1 pb-3 text-sm">
          {duration && (
            <div className="flex space-x-1">
              <div className="w-32 flex-shrink-0 text-gray-500">
                {t('venue.activities.duration')}
              </div>
              <div>{duration}</div>
            </div>
          )}
          {persons && (
            <div className="flex space-x-1">
              <div className="w-32 flex-shrink-0 text-gray-500">
                {t('venue.activities.groupSize')}
              </div>
              <div>{persons}</div>
            </div>
          )}
          {price && (
            <div className="flex space-x-1">
              <div className="w-32 flex-shrink-0 text-gray-500">{t('venue.activities.price')}</div>
              <div>{price}</div>
            </div>
          )}
        </div>
      )}
      {href && (
        <div className="text-sm">
          <a href={href} target="_blank" rel="noreferrer" className="inline-flex items-center">
            {t('venue.activities.openLink')}
            <IconArrowTopRight className="ml-2" />
          </a>
        </div>
      )}
    </div>
  )
}

export default CardActivity
